import { useState, useEffect } from "react";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { crearPaqueteMayoritaAction, obtenerPaqueteMayoristaAllAction, obtenerPaqueteTerresteAction } from "./../../../ducks/proveedorMayoristaDuck"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"

export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    clavePaquete: yup
        .string("Ingrese una clave paquete")
        .required("Es requerido"),
    nombrePaquete: yup
        .string("Ingrese nombre de paquete")
        .required("Es requerido"),
    tipoCambioPrevisto: yup
        .number("Ingresa un tipo de cambio")
        .positive("Monto positivo")
        .required("Es requerido")
})

const initialValues = {
    monto: 0,
    clavePaquete: "",
    nombrePaquete: "",
    tipoCambioPrevisto: 0,
}

const usePaqueteTerrestes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerPaqueteTerresteAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const FPaqueteMayorista = () => {
    usePaqueteTerrestes()

    const { listaTerrestres } = useSelector(store => store.proveedorMayorista)
    const [open, setOpen] = useState(false)
    /** Cambiar el ID del provedor a 3 */
    const catalogoGrupoPaquete = useApi(`Supplier/groupPack/${7}`);
    const [proveedorTerrestre, setProveedorTerrestre] = useState(0)
    const [idGrupoPaquete, setIdGrupoPaquete] = useState(0)
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FormularioReservaStyle()
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    const onClick = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        setTipoMoneda(0)
        formik.resetForm(initialValues);
    }
    const handleSelecProveedorTerrestre = (event) => {
        setProveedorTerrestre(event.target.value)
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const onSave = (values) => {
        if (proveedorTerrestre === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona un proveedor valido",
            })
            return null
        }
        if (tipoMoneda === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        if (proveedorTerrestre === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        dispatch(onLoadAnction({ message: '' }))
        dispatch(crearPaqueteMayoritaAction({
            ClavePaquete: values?.clavePaquete,
            IdMoneda: tipoMoneda,
            IdPaqueteProveedorTerrestre: proveedorTerrestre,
            Nombre: values?.nombrePaquete,
            PrecioPublico: values?.monto,
            TipoCambioPrevisto: values?.tipoCambioPrevisto,
            IdProveedorGrupoPaquete: idGrupoPaquete,
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerPaqueteMayoristaAllAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />}>
                Nuevo paquete
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo terrestre`}
                />

                <form onSubmit={formik.handleSubmit}>

                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={4}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lGrupoPaqueter">Grupo</InputLabel>
                                <Select
                                    labelId="lGrupoPaqueter"
                                    id="SGrupoPaqueter"
                                    name="proveedor"
                                    value={idGrupoPaquete}
                                    onChange={(e) => setIdGrupoPaquete(e.target.value)}
                                    label="Grupo"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoGrupoPaquete.map((item, index) => (
                                        <MenuItem key={item.IdProveedorGrupoPaquete} value={item.IdProveedorGrupoPaquete}>
                                            {item.grupoPaquete.Descripcion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lMayoristaProveedorTerrestre">Proveedor terrestre</InputLabel>
                                <Select
                                    labelId="lMayoristaProveedorTerrestre"
                                    id="SCProveedorTerresteMayorista"
                                    name="proveedorTerrestre"
                                    value={proveedorTerrestre}
                                    onChange={handleSelecProveedorTerrestre}
                                    label="Proveedor terrrestre"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {listaTerrestres.map((paquete, index) => (
                                        <MenuItem key={paquete.IdPaqueteProveedorTerrestre} value={paquete.IdPaqueteProveedorTerrestre}>
                                            {`${paquete.ClavePaquete} - ${paquete.Nombre}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Monto"
                                label="Monto"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-clavePaquete"
                                label="Clave paquete"
                                type="text"
                                variant="outlined"
                                name="clavePaquete"
                                value={formik.values.clavePaquete}
                                onChange={formik.handleChange}
                                error={formik.touched.clavePaquete && Boolean(formik.errors.clavePaquete)}
                                helperText={formik.touched.clavePaquete && formik.errors.clavePaquete}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Nombre"
                                label="Nombre paquete"
                                type="text"
                                variant="outlined"
                                name="nombrePaquete"
                                value={formik.values.nombrePaquete}
                                onChange={formik.handleChange}
                                error={formik.touched.nombrePaquete && Boolean(formik.errors.nombrePaquete)}
                                helperText={formik.touched.nombrePaquete && formik.errors.nombrePaquete}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-tipoPrevisto"
                                label="Tipo de cambio previsto"
                                type="text"
                                variant="outlined"
                                name="tipoCambioPrevisto"
                                value={formik.values.tipoCambioPrevisto}
                                onChange={formik.handleChange}
                                error={formik.touched.tipoCambioPrevisto && Boolean(formik.errors.tipoCambioPrevisto)}
                                helperText={formik.touched.tipoCambioPrevisto && formik.errors.tipoCambioPrevisto}
                                className={classes.textField}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}
export default FPaqueteMayorista